import React from "react";
import JobSchedulesCalendar from "./JobSchedulesCalendar";

function JobSchedulesCalendarView({
    jobSchedules,
    selectedRows,
    onSelectedRowsChange,
    onRefresh,
    onEventClick,
    onEditJob,
    filterText,
}) {
    return (
        <JobSchedulesCalendar
            jobSchedules={jobSchedules}
            onRefresh={onRefresh}
            onEventClick={onEventClick}
            onEditJob={onEditJob}
            filterText={filterText}
        />
    );
}

export default JobSchedulesCalendarView;
